<template>
  <div class="rating-stats-block d-flex align-items-center" :class="{ 'rating-stats-block--compact': compact }">
    <div class="text-center" v-b-tooltip.hover :title="ratingTooltip">
      <div
          class="rating-stats-block__value"
          :class="[ratingClass, { 'rating-stats-block__value--editable': ratingEditable }]"
          @click="ratingEditable && $emit('rating-click')"
      >{{ rating != null ? rating : '—' }}</div>
      <div class="rating-stats-block__label text-muted">
        <feather-icon v-if="compact" icon="Edit3Icon" size="12" />
        <template v-else>Установленный</template>
      </div>
    </div>
    <div class="text-center" v-b-tooltip.hover :title="calculatedTooltip">
      <div class="rating-stats-block__value" :class="calculatedClass">{{ calculated != null ? calculated : '—' }}</div>
      <div class="rating-stats-block__label text-muted">
        <feather-icon v-if="compact" icon="CpuIcon" size="12" />
        <template v-else>Рассчитанный</template>
      </div>
    </div>
    <div v-if="platforms.length || refreshable" class="d-flex align-items-center" style="gap: 0.5rem;">
      <div class="rating-stats-block__platforms">
        <div
            v-for="platform in platforms"
            :key="platform.label"
            class="text-nowrap"
            v-b-tooltip.hover
            :title="platform.tooltip"
        >
          <span
              class="rating-stats-block__service"
              :style="{ backgroundColor: platform.color, color: platform.textColor }"
          >{{ platform.label }}</span>
          <span class="font-weight-bold ml-25">{{ platform.value }}</span>
        </div>
      </div>
      <b-button
          v-if="refreshable"
          variant="flat-secondary"
          size="sm"
          class="btn-icon p-25"
          v-b-tooltip.hover
          title="Обновить данные площадок"
          @click="!refreshing && $emit('refresh')"
      >
        <b-spinner v-if="refreshing" small />
        <feather-icon v-else icon="RefreshCwIcon" size="12" />
      </b-button>
    </div>
  </div>
</template>

<script>
import { BButton, BSpinner, VBTooltip } from 'bootstrap-vue'
import { formatNumber, shortNumber } from '@core/utils/filter'

export default {
  name: 'RatingStatsBlock',
  components: {
    BButton,
    BSpinner,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    rating: {
      type: Number,
      default: null,
    },
    calculated: {
      type: Number,
      default: null,
    },
    lastfm: {
      type: Number,
      default: null,
    },
    spotify: {
      type: Number,
      default: null,
    },
    yandexMonthlyListeners: {
      type: Number,
      default: null,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    ratingEditable: {
      type: Boolean,
      default: false,
    },
    refreshable: {
      type: Boolean,
      default: false,
    },
    refreshing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ratingTooltip() {
      if (this.ratingEditable) return 'Установленный рейтинг — нажмите, чтобы изменить'
      return this.compact ? 'Установленный рейтинг' : ''
    },
    calculatedTooltip() {
      return this.compact ? 'Рассчитанный рейтинг' : ''
    },
    ratingClass() {
      return this.rating != null ? 'text-success font-weight-bolder' : 'text-muted'
    },
    calculatedClass() {
      // Если установленного рейтинга нет, главным становится рассчитанный
      return this.rating == null && this.calculated != null
        ? 'text-success font-weight-bolder'
        : 'text-muted'
    },
    platforms() {
      const result = []
      if (this.lastfm != null) {
        result.push({ label: 'LF', color: '#d51007', textColor: '#fff', value: this.shortNumber(this.lastfm), tooltip: `Last.fm: ${formatNumber(this.lastfm)}` })
      }
      if (this.spotify != null) {
        result.push({ label: 'SP', color: '#1db954', textColor: '#fff', value: this.shortNumber(this.spotify), tooltip: `Прослушивания Spotify: ${formatNumber(this.spotify)}` })
      }
      if (this.yandexMonthlyListeners != null) {
        result.push({ label: 'YA', color: '#ffcc00', textColor: '#1a1a1a', value: this.shortNumber(this.yandexMonthlyListeners), tooltip: `Слушатели Яндекс.Музыки за месяц: ${formatNumber(this.yandexMonthlyListeners)}` })
      }
      return result
    },
  },
  methods: {
    shortNumber,
  },
}
</script>

<style scoped>
.rating-stats-block {
  gap: 1.25rem;
}
.rating-stats-block__value {
  font-size: 1.75rem;
  line-height: 1.1;
}
.rating-stats-block__label {
  font-size: 0.75rem;
}
.rating-stats-block__value--editable {
  cursor: pointer;
  border-bottom: 1px dashed currentColor;
}
.rating-stats-block__service {
  display: inline-block;
  min-width: 1.5rem;
  padding: 0 0.25rem;
  border-radius: 3px;
  font-size: 0.6rem;
  font-weight: 700;
  line-height: 1.5;
  text-align: center;
  vertical-align: text-bottom;
}
.rating-stats-block__platforms {
  font-size: 0.85rem;
  line-height: 1.35;
}
.rating-stats-block--compact {
  gap: 0.75rem;
}
.rating-stats-block--compact .rating-stats-block__value {
  font-size: 1.15rem;
}
.rating-stats-block--compact .rating-stats-block__label {
  font-size: 0.65rem;
}
.rating-stats-block--compact .rating-stats-block__platforms {
  font-size: 0.7rem;
  line-height: 1.3;
}
</style>
